import {FileManager} from '../../shared/Models/FileManager';

export class ServiceRemark {
  public id: number;
  public subject: string;
  public message: string;
  public phone: string;
  public files: FileManager[] = [];
}
